import React from 'react';
import { DatePicker, TimePicker } from '@material-ui/pickers';
import { createMuiTheme, Grid, ThemeProvider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import Header from '../../common/Header';
import { addThisTimeSlot, getMyTimeSlots } from './redux/timeSlotsActions';
import TimeSlotsList from './components/timeSlotsList';

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#00b074',
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: '#00b074',
        '&:hover': {
          backgroundColor: '#019563',
        },
      },
    },
  },
});

const useStyles = makeStyles(() => ({
  btn: {
    background: '#00b074',
    borderRadius: 5,
    padding: '13px 0px',
    marginLeft: 35,
    width: 160,
    fontWeight: 'bold',
    textAlign: 'center',
    cursor: 'pointer',
    color: 'white',
    transition: 'background-color 0.5s ease',
    '&:hover': {
      background: '#019563',
    },
  },
}));

function MyTimeSlots() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [date, changeDate] = React.useState(new Date());
  const [startTime, changeStartTime] = React.useState(new Date());
  const [endTime, changeEndTime] = React.useState(new Date());

  React.useEffect(() => {
    dispatch(getMyTimeSlots());
  }, []);

  const addTimeSlot = () => {
    const timeSlotStart = moment(date);
    timeSlotStart.set({
      h: moment(startTime).format('HH'),
      m: moment(startTime).format('mm'),
    });
    const timeSlotEnd = moment(date);
    timeSlotEnd.set({
      h: moment(endTime).format('HH'),
      m: moment(endTime).format('mm'),
    });
    console.log({
      startTime: moment(timeSlotStart).format(),
      endTime: moment(timeSlotEnd).format(),
    });
    dispatch(
      addThisTimeSlot({
        startTime: moment(timeSlotStart).format(),
        endTime: moment(timeSlotEnd).format(),
      })
    );
  };

  return (
    <>
      <Header />
      <ThemeProvider theme={materialTheme}>
        <div
          style={{
            display: 'flex',
            margin: '50px 20px',
          }}
        >
          <div>
            <DatePicker
              autoOk
              orientation="portrait"
              variant="static"
              openTo="date"
              value={date}
              onChange={changeDate}
              disablePast
            />
          </div>
          <div style={{ flexGrow: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div>
                <div style={{ marginBottom: 10 }}>Start Time</div>
                <div>
                  <TimePicker
                    autoOk
                    variant="inline"
                    openTo="hours"
                    value={startTime}
                    onChange={changeStartTime}
                    minutesStep={5}
                    inputVariant="outlined"
                  />
                </div>
              </div>
              <div style={{ marginLeft: 35 }}>
                <div style={{ marginBottom: 10 }}>End Time</div>
                <div>
                  <TimePicker
                    autoOk
                    variant="inline"
                    openTo="hours"
                    value={endTime}
                    onChange={changeEndTime}
                    minutesStep={5}
                    inputVariant="outlined"
                  />
                </div>
              </div>
              <div>
                <div
                  style={{ marginTop: 33 }}
                  className={classes.btn}
                  onClick={addTimeSlot}
                >
                  Add Time Slot
                </div>
              </div>
            </div>
            <div>
              <TimeSlotsList />
            </div>
          </div>
        </div>
      </ThemeProvider>
    </>
  );
}

export default MyTimeSlots;
